// components/PatientHeader.jsx
import React from 'react';
import { Avatar, Typography } from 'antd';
import { MailOutlined, HomeOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { getImg } from '../../Api/getImg';


const { Title, Text } = Typography;

const PatientHeader = ({ patient }) => {
  const defaultImage = "https://res.cloudinary.com/dk2uh7sho/image/upload/v1750278754/default-img_tbc2pe.jpg";
  
  return (
    <div className="flex items-center gap-4 mb-6">
      <Avatar 
        src={getImg(patient.imageId) || defaultImage} 
        size={100} 
        alt={`${patient.fullName} profile`}
      />
      <div>
        <Title level={3} className="!mb-1 text-[#298d9f]">
          {patient.fullName}
        </Title>
        <Text type="secondary" className="block">
          <MailOutlined /> {patient.email}
        </Text>
        <Text type="secondary" className="block">
          <HomeOutlined /> {patient.clinics?.[0]?.name || 'N/A'}
        </Text>
      </div>
    </div>
  );
};

PatientHeader.propTypes = {
  patient: PropTypes.shape({
    fullName: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    imageId: PropTypes.string,
    clinics: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string
    }))
  }).isRequired
};

export default PatientHeader;